export const useStyles = theme => ({
  dlContainer: {
    padding: '10px',
    width: '80vw',
  },
  dlCloseButton: {
    backgroundColor: '#0D6A41',
    color: '#fff',
    font: 'normal normal 20px Maax-Black',
    padding: '10px 40px 10px 40px',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#0D6A41',
    },
  },
  dlCloseButtonZurich: {
    backgroundColor: '#2167AE',
    color: '#fff',
    font: 'normal normal 20px Maax-Black',
    padding: '10px 40px 10px 40px',
    borderRadius: "100px",
    '&:hover': {
      backgroundColor: '#fff',
      color: '#2167AE',
    },
  },
  dlCloseButtonDerby: {
    backgroundColor: '#00A8B6',
    color: '#fff',
    padding: '5px 15px 5px 15px',
    '&:hover': {
      backgroundColor: '#fff',
      color: '#00A8B6',
    },
  }
});
